module.exports = __webpack_public_path__ + "img/reclaimed-materials.e9772f5b.jpg";